module.exports = __webpack_public_path__ + "img/no_announcement.ba76aac8.svg";